/* eslint-disable @typescript-eslint/dot-notation */
import { isDev } from '../config';
import { Layer } from '../controllers/http-client/http-client.interfaces';

export function devMiddleware(next: Layer) {
  return async (req: Request) => {
    if (!isDev) {
      return next(req);
    }

    const res = await next(req);
    const url = new URL(req.url);

    if (!window['dev']) {
      window['dev'] = {};
    }

    window['dev'][url.pathname] = await res.clone().json();
    return res;
  };
}
